<div id="ais_148_wrapper" class="ari-image-slider-wrapper ari-is-theme-default ari-image-slider-wCtrlNav">
    <div id="ais_148" class="ari-image-slider nivoSlider">
      <img src="/assets/images/background/Hotedršica_aerial.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Danes.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Gasilci.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Mlin.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Nekoc.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Nic1.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Nic2.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Nic3.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Tek.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Zejna1.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Zejna2.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/Zemljanke.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/folklora.jpg" alt="" class="imageslider-item" />
      <img src="/assets/images/slike_slide/tekaski_treningi1.jpg" alt="" class="imageslider-item" />
      
      <!-- Active Image -->
      <img class="nivo-main-image" src="/assets/images/background/Hotedršica_aerial.jpg" alt="" style="width: 600px; height: 250px; overflow: hidden;">
      <div class="nivo-caption"></div>
      <div class="nivo-directionNav">
        <a class="nivo-prevNav">Prev</a>
        <a class="nivo-nextNav">Next</a>
      </div>
    </div>
    <!-- Thumbnail Controls -->
    <div class="nivo-controlNavHolder">
      <div class="nivo-controlNav">
        <a rel="0" class="nivo-control">
          <span class="nivo-thumbNavWrapper">1</span>
        </a>
        <a rel="1" class="nivo-control">
          <span class="nivo-thumbNavWrapper">2</span>
        </a>
        <!-- Add more thumbnails as needed -->
      </div>
    </div>
  </div>
  